var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"oo-module",class:_vm.isSushi && 'montserrat-500',style:(_vm.getloadingBarDone ? _vm.getStyle() : ''),attrs:{"id":"app"}},[_c(_vm.layout,{tag:"component"},[_c('router-view')],1),_c('body-skeleton',{directives:[{name:"show",rawName:"v-show",value:(
      (!_vm.storeMenu || !_vm.getloadedMenu) && !_vm.isMobile() && !_vm.isInStoreSelection
    ),expression:"\n      (!storeMenu || !getloadedMenu) && !isMobile() && !isInStoreSelection\n    "}]}),_c('alert-modal')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }